import React, { Component } from "react";
import { Accessor, ColorX, GFunc, LocaleX, NavX, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XButton, XDiv, XImage, XText } from "IZOX/_X";
// import PAReceipt from "./_pages/PAReceipt";
// import PAExSoon from "./_pages/PAExSoon";
// import NewPolicy from "../PAAllPolicies/_gears/NewPolicy";
// import NewClaim from "../PAClaims/_gears/NewClaim";
import { observer } from "mobx-react";
import PDCContainer from "../shared/PDCContainer/PDCContainer";
import NewPolicy from "../PDCAllPolicies/_gears/NewPolicy";
import NewClaim from "../PDCClaims/_gears/NewClaim";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class PDCDashboard extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      tab: "receipt"
    };
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PDCDashboard.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout);
    if(this.interval) clearInterval(this.interval);
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _setTimeout = (func, delay) => {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(func, delay);
  }

  _setInterval = (func, interval) => {
    if(this.interval) clearInterval(this.interval);
    this.interval = setInterval(func, interval);
  }

  _toTab = (tab) => {
    this.setState({
      tab: tab
    });
  }

  AddPolicy = () => {
    GFunc.Backdrop(() => {
      return (
        <NewPolicy/>
      );
    }, {}, false);
  }

  CheckPolicy = () => {
    let {history} = this.props;
    NavX.Goto(history, "/DCustomer/AllPolicies");
  }

  RenewPolicy = () => {
    let {history} = this.props;
    NavX.Goto(history, "/DCustomer/AllPolicies?status=ExpirySoon", false, false);
  }

  AddClaim = () => {
    GFunc.Backdrop(() => {
      return (
        <NewClaim/>
      );
    }, {}, false);
  }

  CheckClaim = () => {
    let {history} = this.props;
    NavX.Goto(history, "/DCustomer/Claim");
  }

  ChangeInformation = () => {
    let {history} = this.props;
    NavX.Goto(history, "/DCustomer/AccountInfo");
  }

  renderTabBtn(_tab, text, extraStyle){
    let {tab} = this.state;
    let isTab = tab === _tab;
    return (
      <XButton color={ColorX.CSS(isTab? "pureWhite" : "Gray4")}
        bgColor={ColorX.CSS(isTab ? "Axit" : "pureWhite")}
        width={112} zIndex={isTab ? 5 : 0}
        onPress={() => this._toTab(_tab)}
        style={{
          ...extraStyle,
          borderRadius: "10px 10px 0px 0px",
          boxShadow: `0px 2px 2px 2px ${ColorX.CSS("greyOut", 0.5)}`
        }}>
        <HStack>
          <XText fontSize={14}>
            {LocaleX.Parse(text)}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderTabs(){
    return (
      <HStack HAlign="[">
        {this.renderTabBtn("receipt", {EN: "Receipt", TC: "收據"})}
        {this.renderTabBtn("expirysoon", {EN: "Expiry Soon", TC: "即將過期"}, {marginLeft: -10})}
      </HStack>
    );
  }

  renderQABtn(func, src, caption){
    return (
      <XButton onPress={func} width={237} height={237} m={10} padding={0}
        bgColor={ColorX.CSS("pureWhite")} shadow notInjectColor>
        <VStack fullWidth spacing={10}>
          <XDiv width={142} height={142} round={"50%"} p={36}
            bgColor={ColorX.CSS("Axit", 0.1)}>
            <XImage source={src} width={70} height={70}/>
          </XDiv>
          <XText color={ColorX.CSS("Active")} bold>
            {LocaleX.Parse(caption)}
          </XText>
        </VStack>
      </XButton>
    );
  }

  renderQABtnM(func, src, caption){
    let iconWidth = window.innerWidth * 0.053;
    return (
      <XButton onPress={func} width={window.innerWidth * 0.38} m={10} pV={5}
        bgColor={ColorX.CSS("pureWhite")} shadow 
        shadowColor={ColorX.CSS("greyOut", 0.5)} notInjectColor>
        <VStack fullWidth spacing={5} pB={15}>
          <XDiv width={iconWidth * 2} 
            height={iconWidth * 2} round={"50%"} p={iconWidth / 2}
            bgColor={ColorX.CSS("Axit", 0.1)}>
            <XImage source={src} width={iconWidth} 
              height={iconWidth}/>
          </XDiv>
          <XText color={ColorX.CSS("Active")} bold fontSize={13} noWrap>
            {LocaleX.Parse(caption)}
          </XText>
        </VStack>
      </XButton>
    );
  }

  renderQuickActions(){
    return (
      <VStack fullWidth bgColor={ColorX.CSS("NotQuiteWhite")}
        p={16} pT={70} spacing={20}>
          <XText bold color={ColorX.CSS("Grass")} fontSize={32}>
            {LocaleX.Parse({
              EN: "Quick Actions",
              TC: "快速啟動"
            })}
          </XText>
        <HStack flexWrap="wrap" fullWidth>
          {this.renderQABtn(this.AddPolicy, 
            "/Images/QA/addpolicy.svg",
            {
              EN: "Add Policy",
              TC: "新增保單"
            }
          )}
          {this.renderQABtn(this.CheckPolicy, 
            "/Images/QA/checkpolicy.svg",
            {
              EN: "Check Policy",
              TC: "查詢保單"
            }
          )}
          {this.renderQABtn(this.RenewPolicy, 
            "/Images/QA/renewpolicy.svg",
            {
              EN: "Renew Policy",
              TC: "更新保單"
            }
          )}
          {this.renderQABtn(this.AddClaim, 
            "/Images/QA/addclaim.svg",
            {
              EN: "Add Claim",
              TC: "新增索償"
            }
          )}
          {this.renderQABtn(this.CheckClaim, 
            "/Images/QA/checkclaim.svg",
            {
              EN: "Check Claim",
              TC: "查詢索償"
            }
          )}
          {this.renderQABtn(this.ChangeInformation, 
            "/Images/QA/changeinformation.svg",
            {
              EN: "Change Information",
              TC: "變更個人資料"
            }
          )}
        </HStack>
      </VStack>
    );
  }

  renderQuickActionsM(){
    return (
      <VStack fullWidth bgColor={ColorX.CSS("NotQuiteWhite")}
          pT={30} pB={30}>
          <XText bold color={ColorX.CSS("Grass")} fontSize={32}>
            {LocaleX.Parse({
              EN: "Quick Actions",
              TC: "快速啟動"
            })}
          </XText>
        <HStack pH={4} flexWrap="wrap" fullWidth>
          {this.renderQABtnM(this.AddPolicy, 
            "/Images/QA/addpolicy.svg",
            {
              EN: "Add Policy",
              TC: "新增保單"
            }
          )}
          {this.renderQABtnM(this.CheckPolicy, 
            "/Images/QA/checkpolicy.svg",
            {
              EN: "Check Policy",
              TC: "查詢保單"
            }
          )}
          {this.renderQABtnM(this.RenewPolicy, 
            "/Images/QA/renewpolicy.svg",
            {
              EN: "Renew Policy",
              TC: "更新保單"
            }
          )}
          {this.renderQABtnM(this.AddClaim, 
            "/Images/QA/addclaim.svg",
            {
              EN: "Add Claim",
              TC: "新增索償"
            }
          )}
          {this.renderQABtnM(this.CheckClaim, 
            "/Images/QA/checkclaim.svg",
            {
              EN: "Check Claim",
              TC: "查詢索償"
            }
          )}
          {this.renderQABtnM(this.ChangeInformation, 
            "/Images/QA/changeinformation.svg",
            {
              EN: "Change Information",
              TC: "變更個人資料"
            }
          )}
        </HStack>
      </VStack>
    );
  }

  renderNormal(){
    return (
      <PDCContainer>
        {this.renderQuickActions()}
      </PDCContainer>
    );
  }

  renderMobile(){
    return (
      <PDCContainer>
        {this.renderQuickActionsM()}
      </PDCContainer>
    );
  }

  render(){
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal(),
    });
  }
}

export default observer(PDCDashboard);
